/**
 * Announcer script. Single source of truth for both the runtime announcer and the offline
 * generator (`bun tools/voice/generate.ts`), which renders each line to assets/audio/vo/<id>.mp3.
 *
 * The announcer only reports what changed on the objective and in the match. Heroes don't speak:
 * their ultimates are called out by their themes (see theory.ts).
 */
export const ANNOUNCER = {
  /** Kokoro-82M voice id and speaking rate used by the generator. */
  voice: "af_heart",
  speed: 1.02,
  lines: {
    round_1: "Round one.",
    round_2: "Round two.",
    round_3: "Round three.",
    round_final: "Final round.",
    unlocked: "Objective unlocked.",
    capturing: "We're capturing the objective.",
    enemy_capturing: "The enemy is capturing the objective!",
    contested: "The objective is contested.",
    captured: "We've captured the objective.",
    enemy_captured: "The enemy has captured the objective.",
    lost: "We've lost the objective!",
    near_win: "We're close to victory. Hold the objective.",
    enemy_near_win: "The enemy is close to victory!",
    overtime: "Overtime!",
    round_won: "We won the round!",
    round_lost: "We lost the round.",
    victory: "Victory!",
    defeat: "Defeat.",
    revived: "You've been revived.",
    prepare_attack: "Prepare to attack.",
    prepare_defend: "Prepare to defend.",
    payload_moving: "The payload is moving.",
    enemy_payload_moving: "The enemy is moving the payload!",
    checkpoint: "Checkpoint reached.",
    enemy_checkpoint: "The enemy has reached a checkpoint!",
    rolling_back: "The payload is rolling back!",
    payload_near: "The payload is almost there!",
    enemy_payload_near: "The enemy payload is almost there!",
    delivered: "Payload delivered!",
    enemy_delivered: "The enemy delivered the payload.",
    switch_sides: "Switching sides.",
    draw: "It's a draw.",
  },
} as const;

export type LineId = keyof typeof ANNOUNCER.lines;
